customElements.whenDefined('search-form').then(() => {
  class MainSearch extends SearchForm {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"]');
      this.setupEventListeners();
    }

    setupEventListeners() {
      let allSearchForms = [];
      this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      if (allSearchForms.length < 2) return;
      allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
      this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.keepInSync('', this.input);
      }
    }

    onInput(event) {
      const target = event.target;
      this.keepInSync(target.value, target);
    }

    onInputFocus() {
      const isSmallScreen = window.innerWidth < 750;
      if (isSmallScreen) {
        this.scrollIntoView({behavior: 'smooth'});
      }
    }

    keepInSync(value, target) {
      this.allSearchInputs.forEach((input) => {
        if (input !== target) {
          input.value = value;
        }
      });
    }
  }

  customElements.define('main-search', MainSearch);
});

// Filter full search results page to exact matches only.
// Hides product cards whose title does not contain the search term literally.
(function filterExactSearchResults() {
  const params = new URLSearchParams(window.location.search);
  const query = (params.get('q') || '').toLowerCase().trim();
  if (!query) return;

  const run = () => {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    grid.querySelectorAll('.grid__item').forEach(item => {
      const heading = item.querySelector('.card__heading');
      const titleText = (heading || item).textContent.toLowerCase();
      const bodyText  = (item.dataset.body || '').toLowerCase();
      item.style.display = (titleText.includes(query) || bodyText.includes(query)) ? '' : 'none';
    });

    // Update result counters to reflect the filtered count
    const visible = grid.querySelectorAll('.grid__item:not([style*="display: none"]):not([style*="display:none"])').length;
    document.querySelectorAll('.js-product-count').forEach(el => {
      el.textContent = el.textContent.replace(/\d+/, visible);
    });
    document.querySelectorAll('[role="status"]').forEach(el => {
      if (/\d+\s+resultado/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\d+/, visible);
      }
    });
    // Update main heading — in Alpha it's a <p class="h2"> inside .search-results-title
    document.querySelectorAll('h1, h2, h3, h4, p.h2, .search-results-title p, [role="heading"]').forEach(el => {
      if (/\d+\s+resultado/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\d+/, visible);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
